import React from "react";
import Modal from "../../Common/Modal";
import { PDFViewer as PaperviewPDF } from "@paperviewpdf/react-viewer";

import closeBlack from "../../../images/icons/svg/close-black.svg";

import security from "../../../services/Security";
import { loadDocumentUrl } from "../../../lib/axios-client";
import styles from "./TemplatePreviewModal.module.scss";

export default function TemplatePreviewModal(props) {
  var showTemplatePreviewModal = props.showTemplatePreviewModal;
  var setShowTemplatePreviewModal = props.setShowTemplatePreviewModal;
  var template = props.template;

  var token = security.getToken();
  var documentUrl =
    loadDocumentUrl() +
    "/document_templates/preview/" +
    template.id +
    "?token=" +
    token;

  function closeModal() {
    setShowTemplatePreviewModal(false);
  }

  return (
    <Modal
      id="modal"
      visible={showTemplatePreviewModal}
      type={"templatePreviewModal"}
    >
      <div className={styles.activityLogHeaderContainer}>
        <h1 className={styles.activityLogHeading}>{template.title}</h1>

        <img
          className={styles.closeButton}
          onClick={closeModal}
          src={closeBlack}
        />
      </div>
      <div className={styles.webViewerContainer}>
        <PaperviewPDF
          style={{ width: "100%", height: "100%" }}
          config={{
            src: documentUrl,
            wasmUrl: "/pdfium.wasm",
            worker: true,
            theme: {
              preference: "light",
            },
            disabledCategories: [
              "annotation",
              "redaction",
              "selection",
              "history",
              "tools",
              "mode-annotate",
              "mode-shapes",
              "mode-redact",
              "document",
              "panel-comment",
            ],
          }}
        />
      </div>
    </Modal>
  );
}
